<div class="sign-up-section">
  <div class="create-issue-section">
    <div class="row signup_1" >
      <div class="col-md-12">
        <h3 class="cp-header-3 pad-15 cp-border-bottom white-border">
          Corporate ID * <i>(mandatory section)</i></h3>
      </div>

      <div class="col-md-12">
        <form  autocomplete="off" class="form-group" [formGroup]="corporateIdForm" id="corporate-info-form-signup" (ngSubmit)="onCorporateIdDetailsSubmit(corporateIdForm.value)">
          <div class="form-section padding-bottom-0">
            <h4 class="cp-header-4 paddding-bottom-15 cp-border-bottom white-border">
              Contact Details</h4>
            <div class="row">
              <div class="col-lg-8 col-sm-12 col-md-12">
                <div class="align-form-group">
                  <div class="row bottom-margin-10">
                    <div class="col-md-12">
                      <div class="compt-input">
                        <label for="company-name">Company Name</label>
                        <div class="r-value-box resize-height">
                          <input formControlName="company_name" class="form-control block-box-px" id="company-name"
                            type="text">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row bottom-margin-10">
                    <div class="col-md-12">
                      <div class="compt-input">
                        <label for="registered-address">Registered Address</label>
                        <div class="r-value-box resize-height">
                          <input formControlName="company_address" class="form-control block-box-px" id="registered-address"
                            type="text" value="">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row bottom-margin-10">
                    <div class="col-md-12">
                      <div class="compt-input">
                        <label for="communication-address">Communication Address</label>
                        <div class="r-value-box resize-height">
                          <input formControlName="communication_address" class="form-control block-box-px" id="communication-address"
                            type="text">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row bottom-margin-10">
                    <div class="col-md-4 col-xs-12">
                      <div class="compt-input">
                        <label for="corporate-phone-no">Phone No</label>
                        <div class="r-value-box resize-height">
                          <input formControlName="official_telephone_number" class="form-control block-box-px" id="corporate-phone-no"
                            type="number"></div>
                      </div>
                    </div>
                    <div class="col-md-4 col-xs-12">
                      <div class="compt-input">
                        <label for="corporate-fax-no">FAX</label>
                        <div class="r-value-box resize-height">
                          <input formControlName="official_fax_number" class="form-control block-box-px" id="corporate-fax-no"
                            type="number"></div>
                      </div>
                    </div>
                    <div class="col-md-4 col-xs-12">
                      <div class="compt-input">
                        <label for="corporate-email-id">Email ID</label>
                        <div class="r-value-box resize-height">
                          <input formControlName="official_email_address" class="form-control block-box-px" id="corporate-email-id"
                            type="email"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-section padding-bottom-0">
            <h4 class="cp-header-4 paddding-bottom-15 cp-border-bottom white-border">
              Ids and Documents</h4>
            <div class="row">
              <div class="col-md-12">
                <div class="align-form-group">
                  <div class="row">
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <div class="compt-input">
                        <label for="corporate-PAN-no">PAN</label>
                        <div class="r-value-box resize-height">
                          <input formControlName="pan_company" class="form-control block-box-px" id="corporate-PAN-no"
                            type="text"></div>
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <div class="compt-input">
                        <label for="corporate-fax-no">Upload PAN</label>
                        <app-upload-button #uploadPANcard componentId="uploadPANcard" [fileTypes]="fileTypes" [cssOverrideClass]="'upload-resize-height'" [uploadType]="'KEY'"
                          (fileAsDataURL)="uploadDocument($event, 'Company Pan Card', 'pan_proof')"></app-upload-button>
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <div class="compt-input">
                        <label for="submit-incorporation-date-signup">Date of Incorporation</label>
                        <div class="r-value-box  resize-height">
                          <input class="form-control for-small-box" placeholder="dd/mm/yyyy" name="incorporation-date"
                            id="submit-incorporation-date-signup" ngbDatepicker #incorporationdate="ngbDatepicker"
                            formControlName="date_incorporation" [readonly]="true" (click)="incorporationdate.toggle()">
                          <div class="input-group-append icons-calender">
                            <button id="submit-incorporation-date-signup-btn" class="btn" (click)="incorporationdate.toggle()"
                              type="button">
                              <i class="far-i fa fa-calendar"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-3 col-sm-12">
                      <div class="compt-input">
                        <label for="corporate-Upload-COI">Upload COI</label>
                        <app-upload-button #uploadCOI componentId="uploadCOI" [cssOverrideClass]="'upload-resize-height'" [fileTypes]="fileTypes" [uploadType]="'KEY'"
                          (fileAsDataURL)="uploadDocument($event, 'COI', 'coi')"></app-upload-button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-sm-12 col-lg-3">
                      <div class="compt-input">
                        <label for="corporate-CIN-no">CIN</label>
                        <div class="r-value-box resize-height">
                          <input class="form-control block-box-px" id="corporate-CIN-no" formControlName="corporate_identity_number"
                            type="text"></div>
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <div class="compt-input">
                        <label for="corporate-COA">Upload COA</label>
                        <app-upload-button #uploadCOA componentId="uploadCOA" [cssOverrideClass]="'upload-resize-height'" [fileTypes]="fileTypes" [uploadType]="'KEY'"
                          (fileAsDataURL)="uploadDocument($event, 'COA', 'coa')"></app-upload-button>
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <div class="compt-input">
                        <label for="corporate-AOA">Upload AOA</label>
                        <app-upload-button #uploadAOA componentId="uploadAOA" [cssOverrideClass]="'upload-resize-height'" [fileTypes]="fileTypes" [uploadType]="'KEY'"
                          (fileAsDataURL)="uploadDocument($event, 'AOA', 'aoa')"></app-upload-button>
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <div class="compt-input">
                        <label for="corporate-GSTIN">GSTIN</label>
                        <div class="r-value-box resize-height">
                          <input class="form-control block-box-px" formControlName="gstin" id="corporate-GSTIN-no" type="text"
                           ></div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <div class="compt-input">
                        <label for="corporate-company-nature">Nature of Company</label>
                        <div class="r-value-box resize-height">
                          <select id="corporate-company-nature" formControlName="line_of_business" class="form-control select-box select-block-box">
                            <option value="NBFC">NBFC</option>
                            <option value="Banking">Banking</option>
                            <option value="Infrastructure">Infrastructure</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <div class="compt-input">
                        <label for="corporate-entity-identifier">Legal Entity Identifier</label>
                        <div class="r-value-box resize-height">
                          <input class="form-control block-box-px" formControlName="legal_entity_identifier" id="corporate-entity-identifier"
                            type="text"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-section padding-bottom-0" formArrayName="divisions" *ngFor="let division of corporateIdForm.get('divisions')['controls']; let i = index;">
            <button *ngIf="i!== 0" type="button" class="close remove-btn" aria-label="Close" (click)="removeCompanyDivision(i)">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="cp-header-4 paddding-bottom-15 cp-border-bottom white-border">
              Company Division Details # {{i + 1}}
            </h4>
            <div class="row" [formGroupName]="i">
              <div class="col-lg-12">
                <div class="align-form-group">
                  <div class="row">
                    <div class="col-md-2 col-sm-12">
                      <div class="compt-input">
                        <label for="corporate-division">Name of Division</label>
                        <div class="r-value-box resize-height">
                          <input class="form-control block-box-px" id="corporate-division" formControlName="name" type="text"
                           >
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 col-sm-12">
                      <div class="compt-input">
                        <label for="instrument">Instrument</label>
                        <app-icici-select-input [dropdownListType]="'staticItemsList'" [dropDownItemsList]="instruments"
                          [notFoundText]="'Could not find the specified Instrument.'" [placeholder]="'Search and Select Debt Instruments for the company'"
                          [selectedItems]="[{
                                        name: 'Commercial Papers',
                                        value: 1
                                      }]"
                          [selectedItemsIdField]="'value'" (itemSelectedEvent)="onInstrumentChange($event, i)">
                        </app-icici-select-input>
                      </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                      <div class="compt-input">
                        <label for="roles">Roles</label>
                        <app-icici-select-input [dropdownListType]="'staticItemsList'" [dropDownItemsList]="roles"
                          [notFoundText]="'Could not find the specified Role.'" [placeholder]="'Select Roles for the company'"
                          [selectedItems]="[]" [selectedItemsIdField]="'value'" (itemSelectedEvent)="onRoleListChange($event, i)">
                        </app-icici-select-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-section">
            <div class="row">
              <div class="col-lg-3 offset-lg-4">
                <div class="align-form-group pt-0">
                  <div class="btn btn-outline-secondary btn-sm btn-block" (click)="addMoreCompanyDivisions()"(keydown.enter)="addMoreCompanyDivisions()" 
                  (keydown.space)="addMoreCompanyDivisions()">
                    <p class="align-txt">Add More Divisions <span>+</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-section padding-bottom-0" formArrayName="corporate_user" *ngFor="let adminUser of corporateIdForm.get('corporate_user')['controls']; let i = index;">
            <button *ngIf="i!== 0" type="button" class="close remove-btn" aria-label="Close" (click)="removeAdminUser(i)">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="cp-header-4 paddding-bottom-15 cp-border-bottom white-border">
              Admin User Details # {{i + 1}}</h4>
            <div class="row" [formGroupName]="i">
              <div class="col-lg-12">
                <div class="align-form-group">
                  <div class="row">
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <div class="compt-input">
                        <label for="corporate-admin-user">Name of Admin User</label>
                        <div class="r-value-box resize-height">
                          <input class="form-control block-box-px" id="corporate-admin-user" formControlName="name"
                            type="text">
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <div class="compt-input">
                        <label for="corporate-admin-user-phone">Phone No</label>
                        <div class="r-value-box resize-height">
                          <input class="form-control block-box-px" id="corporate-admin-user-phone" formControlName="phone_number"
                            type="text">
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <div class="compt-input">
                        <label for="corporate-admin-user-mobile">Mobile No</label>
                        <div class="r-value-box resize-height">
                          <input class="form-control block-box-px" id="corporate-admin-user-mobile" formControlName="mobile_number"
                            type="text">
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <div class="compt-input">
                        <label for="corporate-admin-user-email">Email ID</label>
                        <div class="r-value-box resize-height">
                          <input class="form-control block-box-px" id="corporate-admin-user-email" formControlName="email"
                            type="text">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <div class="compt-input">
                        <label for="corporate-admin-user-pan">PAN</label>
                        <div class="r-value-box resize-height">
                          <input class="form-control block-box-px" id="corporate-admin-user-pan" formControlName="pan"
                            type="text">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-section">
            <div class="row">
              <div class="col-lg-3 offset-lg-4">
                <div class="align-form-group pt-0">
                  <div class="btn btn-outline-secondary btn-sm btn-block" (click)="addMoreAdminUsers()" (keydown.enter)="addMoreAdminUsers()" 
                  (keydown.space)="addMoreAdminUsers()">
                    <p class="align-txt">Add More Admin Users <span>+</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="hr-top white-border margin-top-0"></div>
          <div class="form-section">
            <div class="row">
              <div class="col-lg-10 rel btn-center-sm">
                <div class="cp-checkbox-default">
                  <div class="form-check has-success">
                    <input type="checkbox" name="tnc-checkbox" id="tnc-checkbox" class="form-check-input"
                      formControlName="tnc_signed">
                    <label class="form-check-label highlight-text" for="tnc-checkbox">
                      <p>By clicking this box, You agree to the terms and conditions mentioned</p>
                    </label>
                    <a (click)="showTncModal()"> here.</a>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 text-right rel btn-center-sm">
                <div class="button-box top-position">
                  <button class="btn btn-md btn-style-right-1 btn-outline-info top-margin-20 text-left" type="submit">Submit</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>